import { mockRanking } from '@/mocks/home';

const changeIcon = (change: string) => {
  if (change === 'up') return { icon: 'ri-arrow-up-line', color: 'text-accent-500' };
  if (change === 'down') return { icon: 'ri-arrow-down-line', color: 'text-foreground-400' };
  return { icon: 'ri-subtract-line', color: 'text-foreground-400' };
};

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">人气排行</h2>
          <p className="text-sm text-foreground-600 max-w-[500px] mx-auto">
            根据热度与读者反馈实时更新，看看本周大家都在追哪些漫画
          </p>
        </div>

        <div className="max-w-[700px] mx-auto">
          <div className="bg-background-50 border border-background-200/70 rounded-lg overflow-hidden">
            {mockRanking.map((item, i) => {
              const change = changeIcon(item.change);
              return (
                <div
                  key={i}
                  className={`flex items-center gap-4 px-5 py-4 cursor-pointer hover:bg-background-100 transition-colors ${
                    i < mockRanking.length - 1 ? 'border-b border-background-200/70' : ''
                  }`}
                >
                  <div className={`w-8 h-8 flex-shrink-0 flex items-center justify-center rounded-full font-heading text-sm ${
                    item.rank === 1
                      ? 'bg-accent-500 text-background-50'
                      : item.rank === 2
                      ? 'bg-primary-500 text-background-50'
                      : item.rank === 3
                      ? 'bg-secondary-500 text-background-50'
                      : 'bg-background-100 text-foreground-700'
                  }`}>
                    {item.rank}
                  </div>

                  <div className="flex-1 min-w-0">
                    <h3 className="text-sm font-medium text-foreground-800">{item.title}</h3>
                    <p className="text-xs text-foreground-500">{item.genre}</p>
                  </div>

                  <div className="flex items-center gap-3 flex-shrink-0">
                    <span className="text-sm font-heading text-primary-500 whitespace-nowrap">{item.heat}</span>
                    <div className={`w-5 h-5 flex items-center justify-center ${change.color}`}>
                      <i className={`${change.icon} text-xs`}></i>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}